// extracted by mini-css-extract-plugin
export var tosLink = "_93-0";